<template>
    <el-dialog
        class="forgot-password-dialog"
        :title="$t('Login.forgot')"
        :visible.sync="visible"
        :modal-append-to-body="false"
        left>
        {{ $t('Login.tip') }}
        <el-form
            ref="form"
            :model="form"
            :status-icon="true"
            label-position="right"
            class="flex flex-col forgot-password-form"
        >
            <el-form-item label="" class="w-full">
                <el-input
                    maxlength="11"
                    v-model="form.phone"
                    type="text"
                    :placeholder="$t('Login.phone')">
                </el-input>
            </el-form-item>
            <el-form-item label="" class="w-full">
                <div class="relative">
                    <el-input
                        v-model="form.kaptchaCode"
                        type="text"
                        :placeholder="$t('Login.kaptchaCode')">
                    </el-input>
                    <img
                        :src="codeImg"
                        class="forgot-code-image absolute"
                        @click="refreshCodeImg()">
                </div>
            </el-form-item>
            <el-form-item label="" class="w-full">
                <div class="relative">
                    <el-input
                        v-model="form.code"
                        type="text"
                        :placeholder="$t('Fill.code')">
                    </el-input>
                    <div
                        @click="handleCode()"
                        class="absolute forgor-handle-code cursor-pointer"
                    >{{ msg }}</div>
                </div>
            </el-form-item>
            <el-form-item label="" class="w-full">
                <el-input
                    v-model="form.password"
                    type="password"
                    :placeholder="$t('Login.password')">
                </el-input>
            </el-form-item>
            <el-form-item label="" class="w-full">
                <el-button
                    @click="submit()"
                    class="forgot-btn"
                    type="primary"
                >{{ $t('Login.confirm') }}</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
    },
    data() {
        return {
            visible: false,
            form: {
                phone: null,
                kaptchaCode: null,
                code: null,
                password: null,
            },
            codeImg: null,
            timer: null,
            second: 60,
            msg: this.$t('Staff.Modify.handle_code'),
        };
    },
    watch: {},
    computed: {},
    methods: {
        open() {
            this.visible = true;
            this.refreshCodeImg();
        },
        refreshCodeImg() {
            this.codeImg = `${API.base_url}/kaptcha?${Math.random()}`;
        },
        handleCode() {
            if (this.timer) return false;

            const myreg = /^(((13[0-9]{1})|(14[0-9]{1})|(17[0-3]{1})|(15[0-3]{1})|(15[5-9]{1})|(18[0-9]{1}))+\d{8})$/;
            if (this.form.phone.length !== 11 && !myreg.test(this.form.phone))
                return $ele.$message.warning(this.$t('Staff.Modify.correct'));

            const form = {
                phone: this.form.phone,
                kaptchaCode: this.form.kaptchaCode,
            };
            API.post('sms/forget-password', form).then(res => {
                $ele.$message.success(this.$t('Staff.Modify.code_success'));
                this.timer = setInterval(() => {
                    if (this.second) {
                        this.second--;
                        this.msg= `${this.second}${this.$t('Staff.Modify.refresh')}`;
                        return;
                    }
                    clearInterval(this.timer);
                    // timer 重置
                    this.timer = null;
                    this.second = 60;
                    this.msg= this.$t('Staff.Modify.again');
                }, 1000);
            });
        },
        submit() {
            API.post('auth/forget-password', this.form).then(res => {
                $ele.$message.success(this.$t('Login.message'));
                this.visible = false;
                clearInterval(this.timer);
            }).catch(() => {
                this.refreshCodeImg();
                this.form.kaptchaCode = null;
                this.form.code = null;
            });
        },
    },
    created() {
    },
};
</script>
<style lang="scss">
    .forgot-password-dialog {
        .el-dialog {
            width: 686px;
        }
    }
    .forgot-password-form {
        width: 330px;
        margin: 0 auto;
        margin-top: 18px;
        .el-input__inner {
            border: 1px solid #dcdddf;
            border-radius: 0;
            padding: 3px 13px;
            color: #3e3835;
            font-size: 12px;
            box-sizing: content-box;
        }
    }
    .forgot-code-image {
        right: -27px;
        top: 1px;
        height: 38px;
        width: 100px;
    }
    .forgor-handle-code {
        color: #0093ff;
        font-size: 14px;
        right: -13px;
        top: 50%;
        transform: translateY(-50%);
    }
    .forgot-btn {
        width: 358px;
        height: 48px;
        font-size: 18px;
    }
</style>
